<template>
	<CatchmentComparisonDialog v-model="catchmentComparison.open" :overlay-target="overlayTarget" :context="catchmentComparison.context" />
	<CompetitorPositioningDialog v-model="competitorPositioning.open" :overlay-target="overlayTarget" :context="competitorPositioning.context" />
</template>

<script setup>
import { inject } from 'vue';
import { useWindowEventDialog } from '@/composables/useWindowEventDialog';
import CatchmentComparisonDialog from '@/components/catchmentArea/CatchmentComparisonDialog.vue';
import CompetitorPositioningDialog from '@/components/competitorPositioning/CompetitorPositioningDialog.vue';

const overlayTarget = inject('overlayTarget', null);

const catchmentComparison = useWindowEventDialog('open-vue-catchment-comparison');
const competitorPositioning = useWindowEventDialog('open-vue-competitor-positioning');
</script>
